import React, {Component} from "react";
import { connect } from 'react-redux'

class ProductSkeletonLoader extends Component {
    constructor(props) {
        super(props)
    }

    componentDidUpdate() {
        if(this.props.loading) {
            this.props.productList.classList.add("hide");
        } else {
            this.props.productList.classList.remove("hide");
        }
    }

    render() { 
        if(!this.props.loading)
            return (<></>)

        return (
            <div className="product-skeleton-loader product-list">
                <ul className="row product-list">
                    {[...Array(5)].map((product, index) => (
                        <li key={index} className="product-list__item columns small-12">
                            <div className="product-list__item__row">
                                <div className="product__figure medium-2 show-for-medium">
                                    <div className="image skeleton-box"></div>
                                </div>
                                <div className="product__info small-12 medium-10">
                                    <div className="small-8 medium-9 name-container">
                                        <div className="product-name skeleton-box"></div>
                                        <div className="product-sub-name skeleton-box"></div>
                                    </div>
                                    <div className="product__figure small-4 show-for-small-only">
                                        <div className="image-mobile product__figure small-9 show-for-small-only skeleton-box"></div>
                                    </div>
                                    <div className="product__price small-5 medium-3 price-container">
                                        <div className="price skeleton-box"></div>
                                    </div>
                                    <div className="product__description-properties-section small-7 medium-12 large-6 props-container">
                                        <div className="product-description skeleton-box"></div>
                                    </div>
                                    <div className="small-12 medium-12 large-6">
                                        <div className="product__quantity-buy-section">
                                            <div className="buy-button product__buy-button-container skeleton-box"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        )
    }
}

const mapStateToProps = ({    
    facetedSearch: {
        loading,
    }}) => {
        return { loading }
    }
 
export default connect(mapStateToProps)(ProductSkeletonLoader);